const Layout = () => System.import('../../Shared/Layout/App/View/Layout.vue');
const Alimento = () => System.import('../App/View/Alimento.vue');

const Cardapio = () => System.import('../App/View/Cardapio.vue');
const CadastroCardapio = () => System.import('../App/View/CadastroCardapio.vue');
const CardapioControleRemocao = () => System.import('../App/View/CardapioControleRemocao.vue');
const CardapioRemocao = () => System.import('../App/View/CardapioRemocao.vue');
const CardapioCopia = () => System.import('../App/View/CardapioCopia.vue');
const CardapioPrato = () => System.import('../App/View/CardapioPrato.vue');

const Prato = () => System.import('../App/View/Prato.vue');
const CadastroPrato = () => System.import('../App/View/CadastroPrato.vue');
const ConexaoPrato = () => System.import('../App/View/ConexaoPrato.vue');
const IngredientePrato = () => System.import('../App/View/IngredientePrato.vue');
const DuplicarPrato = () => System.import('../App/View/DuplicarPrato.vue');

const TipoPrato = () => System.import('../App/View/TipoPrato.vue');
const TipoRefeicao = () => System.import('../App/View/TipoRefeicao.vue');
const Nutricao = () => System.import('../App/View/Nutricao.vue');


export const AlimentoRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      { path: 'alimento', component: Alimento, name: 'alimento', meta: { auth: true } },
      { path: 'alimento/cardapio', component: Cardapio, name: 'alimento-cardapio', meta: { auth: true } },
      { path: 'alimento/cadastrocardapio/:id', component: CadastroCardapio, name: 'alimento-cadastro-cardapio', meta: { auth: true } },
      { path: 'alimento/cardapio/remocao', component: CardapioRemocao, name: 'alimento-cardapio-remocao', meta: { auth: true } },
      { path: 'alimento/cardapio/controleremocao', component: CardapioControleRemocao, name: 'alimento-cardapio-controle-remocao', meta: { auth: true } },
      { path: 'alimento/cardapio/copia', component: CardapioCopia, name: 'alimento-cardapio-copia', props: true, meta: { auth: true } },
      { path: 'alimento/cardapioprato', component: CardapioPrato, name: 'alimento-cardapio-prato', props: true, meta: { auth: true } },

      { path: 'alimento/prato', component: Prato, name: 'alimento-prato', meta: { auth: true } },
      { path: 'alimento/prato/incluir', component: CadastroPrato, name: 'incluir-prato', meta: { auth: true, acao: 'incluir' } },
      { path: 'alimento/prato/alterar/:id', component: CadastroPrato, name: 'alterar-prato', meta: { auth: true, acao: 'alterar' } },
      { path: 'alimento/conexaoprato/:id', component: ConexaoPrato, name: 'alimento-conexao-prato', meta: { auth: true } },
      { path: 'alimento/ingredienteprato/:id', component: IngredientePrato, name: 'alimento-ingrediente-prato', meta: { auth: true } },
      { path: 'alimento/duplicarprato/:id', component: DuplicarPrato, name: 'alimento-duplicar-prato', meta: { auth: true } },

      { path: 'alimento/tipoprato', component: TipoPrato, name: 'alimento-tipoPrato', meta: { auth: true } },
      { path: 'alimento/tiporefeicao', component: TipoRefeicao, name: 'alimento-tipoRefeicao', meta: { auth: true } },
      { path: 'alimento/nutricao', component: Nutricao, name: 'alimento-nutricao', meta: { auth: true } }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Alimento/Rotas/Routes.js